/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const PAIRS: any = feature.getSettingValue('PAIRS');
    const concatValues = [];
    const links = project.getNodeLinks(feature, 'add_to_log');
    if (links.length === 0) {
        return blocks;
    }
    const source = project.getFeature(links[0].getSettingValue('SOURCE_FEATURE')) as BaseNode;
    const sourceParams = source.getPort(links[0].getSettingValue('SOURCE_PORT'))?.params;
    for (let i = 0; i < PAIRS.length; i++) {
        const pair = PAIRS[i];
        const key = pair.getSettingValue('NAME');
        const value = project.parseCodeExpression(pair.getSettingValue('VALUE'), sourceParams, TibboDataType.STRING);
        concatValues.push(`"${key}="+${value}+";"`);
    }

    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `'****${doneLinks[0].getSourceId()}****'` : '';
    for (let i = 0; i < links.length; i++) {
        const link = links[i];
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
tbl_delete_old_records("LOG")
tbl_web_add_row("LOG","\\x22" + lstr(datetime_current_timestamp()) + "\\x22,\\x22" + ${concatValues.join('+')} + "\\x22")
${doneBlock}`,
        });
    }


    return blocks;
};
